import moment from 'moment'
const TIME_FORM = 'YYYY-MM-DD HH:mm:ss'
export const app_list_fields = [
  {
    title: '名称',
    width: 120,
    key: 'name',
    align: 'center'
  },
  {
    title: 'token',
    key: 'app_token',
    align: 'center'
  },
  {
    title:'网址',
    key: 'home_page',
    align: 'center',
    render(h, { row }) {
      return <a href={`https://${row.home_page}`} target="_blank">{row.home_page}</a>
    }
  },
  {
    title:'备注',
    key: 'remark',
    align: 'center'
  },
  {
    title:'更新时间',
    key: 'updated_at',
    align: 'center',
    render(h, { row }) {
      return <span>{moment(row.updated_at).format(TIME_FORM)}</span>
    }
  },
  {
    title:'创建时间',
    key: 'created_at',
    align: 'center',
    render(h, { row }) {
      return <span>{moment(row.created_at).format(TIME_FORM)}</span>
    }
  }
]

export const router_type = [
  {
    value: 'default',
    label: '默认'
  },
  {
    value: 'powerbi',
    label: 'powerbi'
  },
  {
    value: 'tableau',
    label: 'tableau'
  },
  {
    value: 'iframe',
    label: 'iframe'
  },
  {
    value: 'url-open',
    label: '打开网页'
  },
  {
    value: 'button',
    label: '按钮权限'
  },
  {
    value: 'api',
    label: '接口权限'
  }
]
